<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Revision Entry</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">Eco Head Revision</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 3" step="3">Document</v-stepper-step>

      <v-divider></v-divider>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <RevisionEntry v-on:emitForm1="goNextStep"></RevisionEntry>
      </v-stepper-content>

      <v-stepper-content step="2">
        <EcoHeadRevision v-on:emitForm2="goNextStep"></EcoHeadRevision>
      </v-stepper-content>

      <v-stepper-content step="3">
        <Document v-on:emitForm3="goNextStep"></Document>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>


<script>
const commonService = require('../../../services/common.service');

import RevisionEntry from './step_forms/RevisionEntry';
import EcoHeadRevision from './step_forms/EcoHeadRevision';
import Document from './step_forms/Document';
export default {
  components: {
    RevisionEntry,
    EcoHeadRevision,
    Document,
  },
  data() {
    return {
      e1: 0,

      // formSchema: {
      //   //pro_code: "",
      // }
    };
  },

    created () { },
   
    methods: {
    submitOperationActivities()
    {
      commonService.insertFormData(formSchema, "proc_revision").then(res => {           
            if(res.status==1) {
              this.e1 = 2
            }
          });
    },

    goNextStep(num)
    {
      this.e1 = num
    }
  },

};
</script>



// WEBPACK FOOTER //
// src/components/procurement/package_revision/packageRevForm.vue